/**
 * The organization invitation's raw token (ADR-027) is NOT the auth
 * Bearer token - a separate secret, captured from
 * `/organization-invitations/accept?token=...` and held here so it
 * survives a login/register redirect. `sessionStorage` only, its own
 * dedicated key (distinct from Guardian's `pending-token.ts` - two
 * separate token systems must never share one storage slot), never
 * logged, never placed in the TanStack Query cache.
 */

const STORAGE_KEY = 'mahfuz.pendingOrganizationInvitationToken';

export function setPendingInvitationToken(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
}

export function getPendingInvitationToken(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Called on acceptance success only. The backend collapses invalid/used/
 * cancelled/email-mismatch into one indistinguishable error code, so a
 * failed attempt deliberately retains the token instead of clearing it -
 * an email-mismatch case is still recoverable by signing into the correct
 * account and retrying. See accept-invitation-page.tsx.
 */
export function clearPendingInvitationToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
